module.exports = __webpack_public_path__ + "img/BE.0ff4c44a.png";